<template>
  <div
    :class="{
      [$style.checked]: isChecked(option),
      [$style.baseRadioHorizontal]: true,
      [$style.baseRadioHorizontalNewDesign]: isNewDesign,
      [$style.phone]: el.is.phone,
      [$style.noMargin]: !margin
    }"
    @click="onChange(option)"
  >
    <!-- check icon -->
    <img
      :src="getCheckedIcon"
      alt="item image"
      :class="$style.checkedIcon"
      v-show="isChecked(option)"
    />

    <!-- text -->
    <label
      :for="option.label"
      v-html="option.label"
      :class="{ [$style.label]: true, [$style.checked]: isChecked(option) }"
    >
    </label>
  </div>
</template>

<script>
import store from '@/store'

export default {
  props: {
    option: {
      type: Object,
      required: true
    },
    margin: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    // note: new design
    isNewDesign() {
      return store.getters.hausankerDesign
    },
    // note: new design
    getCheckedIcon() {
      if (this.isNewDesign) {
        return require('../../assets/images/checked_new.svg')
      } else {
        return require('../../assets/images/checked.svg')
      }
    },
    el() {
      return store.state.el
    }
  },
  methods: {
    isChecked(option) {
      return this.option.selectedValue !== ''
    },
    getImg(option) {
      return require('../../assets/images/' + option.img + '.png')
    },
    onChange(option) {
      const data = {
        slideName: option.slideName,
        formName: option.formName,
        inputName: option.inputName,
        name: option.name,
        value: option.value,
        additionalForm: option.additionalForm
      }
      // clean other radio selectedValue
      store.dispatch('editRadio', data)
      this.$emit('check', data)
    }
  }
}
</script>

<style lang="scss" module>
@import '@/scss/variables.scss';

.baseRadioHorizontal {
  display: flex;
  cursor: pointer;
  flex-direction: row;
  align-items: center;
  text-align: left;
  line-height: 1.2;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  img {
    width: 24px;
    height: 24px;
  }
}

.baseRadioHorizontal:before {
  content: '';
  border-radius: 50%;
  border: 3px solid $color_grey_2;
  margin-right: 14px;
  width: 24px;
  height: 24px;
}

// note: new design
.baseRadioHorizontalNewDesign::before {
  border: 3px solid $color_border_new;
}

.checkedIcon {
  position: absolute;
}

.label {
  color: $color_grey_1;
  cursor: pointer;
  font-weight: bold;
  width: 75%;
}

.checked {
  font-size: 16px;
  color: $color_font_2;
  font-weight: bold;
}
.noMargin {
  margin-bottom: 0px;
  margin-top: 0px;
  margin-right: 0px;
  margin-left: 0px;
}

// note: PHONE
.phone {
  margin-left: 0;
  font-size: 16px;
  &.baseRadioHorizontal {
    img {
      width: 20px;
      height: 20px;
    }
  }
  .alignLeft {
    padding-left: 0;
    margin-left: 0;
  }
}
.phone::before {
  width: 20px;
  height: 20px;
  border: 2px solid $color_grey_2;
}
</style>
